// extracted by mini-css-extract-plugin
export default {"ncsa":"ncsaCollegeRecruiting__ncsa__STmOP","text":"ncsaCollegeRecruiting__text__du62Z","heading":"ncsaCollegeRecruiting__heading__eDzNO"};